import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight, faListOl } from '@fortawesome/free-solid-svg-icons'

import { Button } from 'plurall-ui'

import styles from './FooterNav.module.css'

const FooterNavButton = ({ item, icon, side }) => (
  <div className={`${styles['button-wrapper']} ${styles[`button-wrapper-${side}`]}`}>
    {item && Object.keys(item).length > 0 && (
      <Link to={`#${item.nid}`}>
        <Button className={styles.button}>
          <span className={styles[`button-caret-${side}`]}>
            <FontAwesomeIcon icon={icon} />
          </span>{' '}
          <span className={styles['button-text']}>
            {item.pos}. <span>{item.title}</span>
          </span>
        </Button>
      </Link>
    )}
  </div>
)

const FooterNav = ({ prevItem, nextItem, presentation }) => (
  <div className={styles.wrapper}>
    <FooterNavButton item={prevItem} icon={faChevronLeft} side='left' />

    <div className={`${styles['button-wrapper']} ${styles['button-wrapper-middle']}`}>
      {presentation && (
        <Link to='#'>
          <Button className={styles.button}>
            <span>
              <FontAwesomeIcon icon={faListOl} />
            </span>{' '}
          </Button>
        </Link>
      )}
    </div>

    <FooterNavButton item={nextItem} icon={faChevronRight} side='right' />
  </div>
)

FooterNavButton.propTypes = {
  item: PropTypes.shape({
    nid: PropTypes.number,
    title: PropTypes.string,
    pos: PropTypes.number,
  }),
  icon: PropTypes.object,
  side: PropTypes.string,
}

FooterNav.propTypes = {
  prevItem: PropTypes.shape({
    nid: PropTypes.number,
    title: PropTypes.string,
    pos: PropTypes.number,
  }),
  nextItem: PropTypes.shape({
    nid: PropTypes.number,
    title: PropTypes.string,
    pos: PropTypes.number,
  }),
  presentation: PropTypes.array,
}

export default FooterNav
